import { ChipsideComponent } from "../chipside-component";

export class Accordion extends ChipsideComponent {
	constructor() {
		super();

		this.multiple = this.hasAttribute("multiple");

		this.classList.add("accordion__container");
	}
}